import {css} from "@emotion/react";

import {ContentItemType} from "../../types/Entry";

interface IContentEmbedIframeProps {
    type: ContentItemType.VIMEO | ContentItemType.YOUTUBE | ContentItemType.SPOTIFY;
    embedUrl: string;
}

const normalizeEmbedUrl = (url: string) => url.replace(/&amp;/g, "&");

export const ContentEmbedIframe = ({type, embedUrl}: IContentEmbedIframeProps) => {
    const isSpotify = type === ContentItemType.SPOTIFY;

    return (
        <iframe
            css={isSpotify ? spotifyIframe : videoIframe}
            src={normalizeEmbedUrl(embedUrl)}
            allow={
                isSpotify
                    ? "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    : "autoplay; fullscreen; picture-in-picture"
            }
            {...(isSpotify ? {loading: "lazy" as const, title: "Spotify"} : {allowFullScreen: true, title: "Video"})}
        />
    );
};

const videoIframe = css`
    border: none;
    display: block;
`;

const spotifyIframe = css`
    border: none;
    display: block;
    width: 100%;
    height: 15.2rem;
    border-radius: 1.2rem;
`;
